import { action as apiAction } from 'api/Api'
import {
  setIsCardInMyBoard
} from '../redux/myBoard'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId } = payload

  const state = getState()

  const myBoardId = state.kanbo.currentUser.myBoardId

  const optimisticAction = optimisticDispatch(dispatch, setIsCardInMyBoard({
    cardId,
    isCardInMyBoard: true
  }))

  try {
    await apiAction('AddVCard', {
      vBoardId: myBoardId,
      cardId,
      position: 0
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
